// Loader.js
import React from "react";
import { Preloader } from "react-materialize";
// import "./Loader.css";

const Loader = () => {
  return (
    <div style={{
      position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.7)", // transparent white overlay
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999 
      }}>
      <Preloader active color="blue" size="big" />
    </div>
  );
};

export default Loader;